import { render } from "./index.vue?vue&type=template&id=58029d13&scoped=true?status=10"
import script from "./index.vue?vue&type=script&lang=js?status=10"
export * from "./index.vue?vue&type=script&lang=js?status=10"

import "./index.vue?vue&type=style&index=0&id=58029d13&lang=less&scoped=true?status=10"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58029d13"]])

export default __exports__